import { useLiveQuery } from "dexie-react-hooks";
import { useState, useEffect } from "react";
import { db } from "../../Utils/Functions/Dexie-Setup";

const DateInput = ({ tableName, primaryKey, fieldName, label, ...rest }) => {
  const record = useLiveQuery(() => db[tableName].get(primaryKey), [primaryKey, tableName]);
  const [date, setDate] = useState("");

  useEffect(() => {
    let dateValue = record ? record[fieldName] : "";
    if (typeof dateValue === 'string' && dateValue.includes('T')) {
      dateValue = dateValue.split('T')[0];
    }
    
    if (typeof dateValue === 'string') {
      const parts = dateValue.split('-');
      if (parts.length === 3) {
        const [year, month, day] = parts;
        const formattedMonth = month.padStart(2, '0');
        const formattedDay = day.padStart(2, '0');
        dateValue = `${year}-${formattedMonth}-${formattedDay}`;
      }
    }
    
    setDate(dateValue);
  }, [record, fieldName])

  useEffect(() => {
    const timeout = setTimeout(() => {
      db[tableName].update(primaryKey, { [fieldName]: date })
    }, 500)

    return () => {
      clearTimeout(timeout)
    }
  }, [date, fieldName, primaryKey, tableName])

  return (
    <div className="mb-5">
      <label htmlFor={`${primaryKey}-${fieldName}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
      <input type="date" value={date} onChange={(e) => setDate(e.target.value)} id={`${primaryKey}-${fieldName}`} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" {...rest} />
    </div>
  )
}

export default DateInput
